
import { defineNuxtPlugin } from '#app'

declare global {
  interface Window {
    _hmt?: Array<unknown[]>
  }
}

const HM_ID = 'b337f95098370f8fbd234b476fb1a0f8'
const HM_SRC = `https://hm.baidu.com/hm.js?${HM_ID}`

const ensureHmScript = () => {
  if (typeof document === 'undefined') return
  if (document.querySelector('script[data-baidu-hm]')) return

  window._hmt = window._hmt || []

  const hm = document.createElement('script')
  hm.src = HM_SRC
  hm.async = true
  hm.dataset.baiduHm = 'true'
  const first = document.getElementsByTagName('script')[0]
  first?.parentNode?.insertBefore(hm, first)
}

const trackPageview = (path: string) => {
  if (typeof window === 'undefined') return
  window._hmt = window._hmt || []
  // 百度要求带前导 /
  const page = path.startsWith('/') ? path : `/${path}`
  window._hmt.push(['_trackPageview', page])
}

export default defineNuxtPlugin((nuxtApp) => {
  try {
    ensureHmScript()

    // 首次进入由 hm.js 自动统计，避免与 afterEach 重复记一次
    let isFirstRoute = true
    nuxtApp.$router.afterEach((to) => {
      if (isFirstRoute) {
        isFirstRoute = false
        return
      }
      trackPageview(to.fullPath)
    })
  } catch (e) {
    console.warn('[baidu-hm] plugin failed safe:', e)
  }
})
